export const CITATION_STYLES = {
    "Estate Rule": { bg: "#EFF6FF", text: "#1D4ED8", border: "#BFDBFE" },
    "Past Successful Appeal": { bg: "#ECFDF5", text: "#047857", border: "#A7F3D0" },
    "Past Failed Appeal": { bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA" },
    "Private Evidence": { bg: "#FDF4FF", text: "#A21CAF", border: "#F5D0FE" },
    "Estate KB": { bg: "#F8FAFC", text: "#475569", border: "#E2E8F0" },
};

export const CONFIDENCE_STYLES = {
    high: "bg-emerald-50 text-emerald-700 border-emerald-200",
    medium: "bg-blue-50 text-blue-700 border-blue-200",
    low: "bg-amber-50 text-amber-700 border-amber-200",
    unknown: "bg-slate-50 text-slate-600 border-slate-200",
};

export function citationLabel(citation) {
    return citation?.kb_label || (citation?.source === "estate_kb" ? "Estate KB" : "Private Evidence");
}

export function citationStyle(citation) {
    return CITATION_STYLES[citationLabel(citation)] || CITATION_STYLES["Estate KB"];
}

export function confidenceLabel(citation) {
    if (citation?.confidence) return citation.confidence;
    if (citation?.score === undefined || citation?.score === null) return "Context match";
    const score = Number(citation.score);
    if (Number.isNaN(score)) return "Context match";
    if (score >= 0.72) return "High confidence";
    if (score >= 0.5) return "Medium confidence";
    return "Low confidence";
}

export function confidenceClass(citation) {
    return CONFIDENCE_STYLES[citation?.confidence_level] || CONFIDENCE_STYLES.unknown;
}

export function sourceCategory(citation) {
    return citation?.source_category || citationLabel(citation);
}
